import {Routes} from '@src/Constant/routes';
import {RouteComponentProps} from '@reach/router';
import React from 'react';
import {KeyRouteMap} from '../types';

// Composants divers et routes vides
const ArtistHomePage = React.lazy(
  () => import('@src/App/components/pages/ArtistHomePage/ArtistHomePage'),
);
const emptyRoute = {
  component: React.lazy(() => {
    const EmptyComponent = () => React.createElement('div');
    return Promise.resolve({default: EmptyComponent});
  }),
};

export const miscRoutes: KeyRouteMap = {
  [Routes.DynamicPage]: emptyRoute,
  [Routes.ARTIST_SERVICE_HOME]: {component: ArtistHomePage},
  [Routes.ARTIST_SERVICE]: emptyRoute,
  [Routes.QUIZ_DETAIL]: emptyRoute,
  [Routes.JOB_TRAINING]: emptyRoute,
  [Routes.THANK_YOU_MODAL]: emptyRoute,
  [Routes.LIVE_EVENTS_ITEM]: emptyRoute,
  [Routes.PROFILE_LEGAL_INFORMATION]: emptyRoute,
};
